import { render, staticRenderFns } from "./express.vue?vue&type=template&id=6c4a8ee3&scoped=true&"
import script from "./express.vue?vue&type=script&lang=js&"
export * from "./express.vue?vue&type=script&lang=js&"
import style0 from "./express.vue?vue&type=style&index=0&id=6c4a8ee3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c4a8ee3",
  null
  
)

export default component.exports